/**
 * BACFREE — Page Load Overlay
 * Shows a brief full-viewport white fade on every page load, across the
 * whole site (all templates) — an entrance effect similar to the one on
 * djistore-malaysia.com. The overlay itself (assets/page-loader.css) is
 * rendered as the very first element inside <body> (see
 * layout/theme.liquid), so it always paints before anything underneath
 * it can be seen.
 *
 * The overlay holds for a short minimum time (so it never flashes by
 * unnoticed on a fast connection), then fades out over 1.3s — which
 * must stay in sync with the CSS transition duration in
 * page-loader.css — and is fully removed from the DOM afterwards so it
 * can never block clicks or scrolling.
 *
 * Disabled in the Theme Editor, so merchants editing the theme aren't
 * interrupted by the overlay every time the preview re-renders.
 */
(function () {
  'use strict';

  var loader = document.getElementById('bacfree-page-loader');
  if (!loader) return;

  var HIDDEN_CLASS = 'bacfree-page-loader--hidden';
  var HOLD_MS = 1000; // minimum time the overlay stays fully visible
  var FADE_MS = 1300; // must match the CSS transition duration
  var hidden = false;

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function removeLoader() {
    if (loader && loader.parentNode) {
      loader.parentNode.removeChild(loader);
    }
    document.documentElement.classList.remove('has-page-loader');
  }

  function hideLoader() {
    if (hidden) return;
    hidden = true;
    loader.classList.add(HIDDEN_CLASS);
    setTimeout(removeLoader, prefersReducedMotion() ? 0 : FADE_MS);
  }

  // Theme Editor: never show the overlay, so merchants aren't interrupted
  // every time a setting change re-renders the preview.
  if (isDesignMode()) {
    removeLoader();
    return;
  }

  document.documentElement.classList.add('has-page-loader');
  setTimeout(hideLoader, prefersReducedMotion() ? 0 : HOLD_MS);

  // Restoring from the browser's back/forward cache: make sure the
  // overlay never reappears or gets stuck on screen.
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) hideLoader();
  });
})();
